











import { Component, Vue } from 'vue-property-decorator';
import MaterialRequestForm from '@/components/forms/MaterialRequestForm.vue';

@Component({
    components: {
        MaterialRequestForm
    }
})
export default class RequestAdd extends Vue {
}
